import { MultiUserConfirmation } from "./MultiUserConfirmation";
export default MultiUserConfirmation;